import React, { useEffect, useMemo } from 'react'
import { formatUploadList } from '../utils/formatUploadList'
import useList from 'hooks/useList'
import { useUploadQueue } from 'hooks/useUploadQueue'
import { canCancelUploadStatus } from '../constants'
import { UPLOAD_STATUS } from 'constants.js'
import { PopOver, OverlayTrigger } from '@tencent/spaui'

export const useUploadingList = props => {
    const { setUploadCount } = props
    const { progress, cancelTask, deleteTask } = useUploadQueue()

    // 注意这里一定要使用useMemo, 否则会造成无限循环
    // derivedData 作为 useList 中useEffect的依赖
    // useEffect中有更新页面的操作, 导致当前组件 rerender
    // formatUploadList 会返回新的值,  所以需要用useMemo优化一下
    const data = useMemo(() => formatUploadList(progress), [progress])
    const { state, setState } = useList({
        // TODO 传入uploadQueen 过滤文件的api
        derivedData: data,
        filterSelectValue: -1,
    })

    useEffect(() => {
        let dataLength = state.data.length
        let dateLengthString = ''
        if (dataLength > 0) {
            if (dataLength > 100) {
                dateLengthString = '(99+)'
            } else {
                dateLengthString = `(${dataLength})`
            }
        }
        setUploadCount(dateLengthString)
    }, [state, setUploadCount])

    const colRender = (type, name, value, rowData = {}) => {
        let content = value
        const originData = rowData.originData || {}
        if (type !== 'head') {
            switch (name) {
                case 'operate': {
                    if (canCancelUploadStatus.includes(originData.status)) {
                        content = (
                            <a
                                href="void:0"
                                onClick={e => {
                                    e.preventDefault()
                                    cancelTask(rowData.fileKey)
                                }}
                            >
                                取消上传
                            </a>
                        )
                    } else if ([UPLOAD_STATUS.FAIL, UPLOAD_STATUS.CANCEL].includes(originData.status)) {
                        content = (
                            <a
                                href="void:0"
                                onClick={e => {
                                    e.preventDefault()
                                    deleteTask(rowData.fileKey)
                                }}
                            >
                                删除
                            </a>
                        )
                    }
                    break
                }
                case 'progress': {
                    if (originData.status === UPLOAD_STATUS.FAIL) {
                        const popover = <PopOver>{originData.errorMessage || '未知原因，请重新尝试'}</PopOver>
                        content = (
                            <div className="channel-package-table-upload with-icon error">
                                <div>
                                    <i className="icon-upload-error"></i>
                                    <span>上传失败</span>
                                    <OverlayTrigger trigger="hover" hideDelayTime={0} overlay={popover}>
                                        <i className="spaui-icon icon-help" style={{ marginLeft: 65 }}>
                                            <i></i>
                                        </i>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        )
                    } else {
                        content = (
                            <div className="channel-package-table-upload">
                                <div
                                    className="table-upload-bg"
                                    style={{
                                        width: rowData.progress + '%',
                                    }}
                                ></div>
                                <div className="value">上传中 {rowData.progress}%</div>
                            </div>
                        )
                    }

                    break
                }
                default:
                    break
            }
        }
        return content
    }

    return { state, setState, colRender }
}

export default useUploadingList
